export default __webpack_public_path__ + "static/media/icon-github.8d8f94f2.webp";